<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        > 
            <v-card
                width="500"
            >  
                 <v-card-title class="white--text pl-4 mb-4 primary">
                    REQUIRED DOCUMENTS
                </v-card-title>
               
                <v-row 
                    align="center"
                    justify="center" 
                    class="pa-4"                  
                >
                    <v-col
                        cols="12"                        
                    >
                        Please upload a scanned copy of the required documents
                        in the appropriate fields below
                    </v-col>
                </v-row>
            </v-card>
        </v-row>

        <v-row
            v-for="document in documents"
            :key="document.label"
        >
            <upload-files 
                v-bind:fileType="document.type"
                v-bind:fileLabel="document.label"
                v-bind:fileTypeAllowed="document.fileAllowed"
                v-bind:fileAccept="document.fileAccept"
            ></upload-files>
        </v-row>

        <v-row
            align="center"
            justify="center"
        >
            <v-card
                class="py-6 px-0 mt-5" 
                width="500" 
                flat
                href="/registration/complete" 
                color="grey lighten-5"              
            >
                <v-btn color="primary" block>Next Section</v-btn>
            </v-card>
        </v-row>
        
    </layout>    
</template>

<script>
import Layout from './layouts/Registration';
import UploadFiles from "./UploadFiles";

export default {
    name: 'Documents',

    components: {
        Layout,
        UploadFiles,
        
    },    

    data: () => ({        
        documents: [
            {
                label: 'Birth Certificate', 
                placeholder: 'Upload your birth certificate', 
                type: 'birth_certificate',
                ref: 'birth_certificate',
                fileAllowed: 'pdf',
                fileAccept: '.pdf',
            },
            {
                label: 'Immunization Card', 
                placeholder: 'Upload your immunization card', 
                type: 'immunization_card',
                ref: 'immunization_card',
                fileAllowed: 'pdf',
                fileAccept: '.pdf',
            },
            {
                label: 'SEA Slip', 
                placeholder: 'Upload your SEA results slip', 
                type: 'sea_slip',
                ref: 'sea_slip',
                fileAllowed: 'pdf',
                fileAccept: '.pdf',
            },
            {
                label: 'Mother ID Card', 
                placeholder: 'Upload mother\'s ID card', 
                type: 'mother_id_card',
                ref: 'mother_id_card',
                fileAllowed: 'pdf',
                fileAccept: '.pdf',
            },
            {
                label: 'Father ID Card', 
                placeholder: 'Upload father\'s ID card', 
                type: 'father_id_card',
                ref: 'father_id_card',
                fileAllowed: 'pdf',
                fileAccept: '.pdf',
            },
            {
                label: 'Guardian ID Card', 
                placeholder: 'Upload guardian\'s ID card', 
                type: 'guardian_id_card',
                ref: 'guardian_id_card',
                fileAllowed: 'pdf',
                fileAccept: '.pdf',
            },
            // {
            //     label: 'Passport Photo', 
            //     placeholder: 'Upload Passport Photo', 
            //     type: 'photo',
            //     ref: 'picture',
            // },
        ],      
        
    }),
    
}
</script>